import { Extension } from '@tiptap/vue-2';
import { MarkType } from '../constants';

export const FontSize = Extension.create({
    name: 'fontSize',
    addOptions() {
        return {
            types: [MarkType.TEXT_STYLE]
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        parseHTML: ({ style }) => style.fontSize?.replace(/['"]+/g, ''),
                        renderHTML: ({ fontSize }) => ({ ...(fontSize && { style: `font-size: ${fontSize}` }) })
                    }
                }
            }
        ];
    },
    addCommands() {
        return {
            setFontSize: fontSize => ({ commands }) => commands.setMark(MarkType.TEXT_STYLE, { fontSize }),
            unsetFontSize: () => ({ chain }) => chain()
                .setMark(MarkType.TEXT_STYLE, { fontSize: null })
                .removeEmptyTextStyle()
                .run()
        };
    }
});
